<template>
  <div class="main">
    <div class="nav">
      <div class="center">
        <img src="./images/logo.png">
        <ul>
          <li @click="scrollToSection('section1')">首页</li>
          <li @click="scrollToSection('section2')">硬件设备</li>
          <li @click="scrollToSection('section3')">显示设备</li>
          <li @click="scrollToSection('section4')">会议设备</li>
          <li @click="scrollToSection('section5')">载具建筑</li>
          <li @click="scrollToSection('section6')">关于我们</li>
        </ul>
      </div>
    </div>
    <div class="banner" ref="section1">
      <video width="1200" height="565" poster="./images/banner.png" autoplay="autoplay" preload="auto"
        controls="controls">
        <source src="./video/model_video.mp4" />
      </video>
    </div>
    <div class="title" ref="section2">
      硬件设备
    </div>
    <div class="article">
      <div class="picture">
        <div class="big">
          <img src="./images/model/hardware/单导设备.png">
          <div class="big_model_title">
            <!-- 单导设备 -->
          </div>
          <div class="big_model_describe">
            <!-- 文艺、简约、品位，从此兼得 -->
          </div>
          <div class="big_title">
            单导设备
          </div>
        </div>
        <div class="small" style="margin-right: 30px;">
          <img src="./images/model/hardware/服务器.png">
          <div class="small_model_title">
            网络服务器
          </div>
        </div>
        <div class="small">
          <img src="./images/model/hardware/光驱.png">
          <div class="small_model_title">
            光驱
          </div>
        </div>
        <div class="small" style="margin-right: 30px;">
          <img src="./images/model/hardware/光线路终端.png">
          <div class="small_model_title">
            光线路终端
          </div>
        </div>
        <div class="small">
          <img src="./images/model/hardware/机架式机箱.png">
          <div class="small_model_title">
            机架式机箱
          </div>
        </div>
      </div>
      <div class="picture" v-if="detail1">
        <div class="big">
          <img src="./images/model/hardware/机器狗.png">
          <div class="big_model_title">
            <!-- 机器狗 -->
          </div>
          <div class="big_model_describe">
            <!-- 文艺、简约、品位，从此兼得 -->
          </div>
          <div class="big_title">
            机器狗
          </div>
        </div>
        <div class="small" style="margin-right: 30px;">
          <img src="./images/model/hardware/苹果机箱.png">
          <div class="small_model_title">
            苹果机箱
          </div>
        </div>
        <div class="small">
          <img src="./images/model/hardware/机箱.png">
          <div class="small_model_title">
            国产机箱
          </div>
        </div>
        <div class="small" style="margin-right: 30px;">
          <img src="./images/model/hardware/网络交换机.png">
          <div class="small_model_title">
            网络交换机
          </div>
        </div>
        <div class="small">
          <img src="./images/model/hardware/主机.png">
          <div class="small_model_title">
            主机
          </div>
        </div>
      </div>
      <div v-if="!detail1" class="more_model" @click="detail1 = true">
        更多模型
      </div>
      <div v-if="detail1" class="more_model" @click="detail1 = false">
        收起
      </div>
    </div>
    <div class="title" ref="section3">
      显示设备
    </div>
    <div class="article">
      <div class="picture">
        <div class="big">
          <img src="./images/model/device/会议屏.png">
          <div class="big_model_title">
            <!-- 单导设备 -->
          </div>
          <div class="big_model_describe">
            <!-- 文艺、简约、品位，从此兼得 -->
          </div>
          <div class="big_title">
            会议屏
          </div>
        </div>
        <div class="small" style="margin-right: 30px;">
          <img src="./images/model/device/LED屏.png">
          <div class="small_model_title">
            LED屏
          </div>
        </div>
        <div class="small">
          <img src="./images/model/device/可视化大屏.png">
          <div class="small_model_title">
            可视化大屏
          </div>
        </div>
        <div class="small" style="margin-right: 30px;">
          <img src="./images/model/device/幕布.png">
          <div class="small_model_title">
            幕布
          </div>
        </div>
        <div class="small">
          <img src="./images/model/device/液晶屏.png">
          <div class="small_model_title">
            液晶屏
          </div>
        </div>
      </div>
    </div>

    <div class="title" ref="section4">
      会议设备
    </div>
    <div class="article">
      <div class="picture">
        <div class="big">
          <img src="./images/model/furniture/办公桌.png">
          <div class="big_model_title">
            <!-- 单导设备 -->
          </div>
          <div class="big_model_describe">
            <!-- 文艺、简约、品位，从此兼得 -->
          </div>
          <div class="big_title">
            办公桌
          </div>
        </div>
        <div class="small" style="margin-right: 30px;">
          <img src="./images/model/furniture/货架.png">
          <div class="small_model_title">
            货架
          </div>
        </div>
        <div class="small">
          <img src="./images/model/furniture/机柜.png">
          <div class="small_model_title">
            机柜
          </div>
        </div>
        <div class="small" style="margin-right: 30px;">
          <img src="./images/model/furniture/立柜.png">
          <div class="small_model_title">
            立柜
          </div>
        </div>
        <div class="small">
          <img src="./images/model/furniture/网络机柜.png">
          <div class="small_model_title">
            网络机柜
          </div>
        </div>
      </div>

      <div class="picture" v-if="detail2">
        <div class="big">
          <img src="./images/model/furniture/指挥桌.png">
          <div class="big_model_title">
            <!-- 机器狗 -->
          </div>
          <div class="big_model_describe">
            <!-- 文艺、简约、品位，从此兼得 -->
          </div>
          <div class="big_title">
            指挥桌
          </div>
        </div>
        <div class="small" style="margin-right: 30px;">
          <img src="./images/model/furniture/投影仪.png">
          <div class="small_model_title">
            投影仪
          </div>
        </div>
        <div class="small">
          <img src="./images/model/furniture/主服务器.png">
          <div class="small_model_title">
            主服务器
          </div>
        </div>
        <div class="small" style="margin-right: 30px;">
          <img src="./images/model/furniture/幕布.png">
          <div class="small_model_title">
            幕布
          </div>
        </div>
      </div>
      <div v-if="!detail2" class="more_model" @click="detail2 = true">
        更多模型
      </div>
      <div v-if="detail2" class="more_model" @click="detail2 = false">
        收起
      </div>
    </div>

    <div class="title" ref="section5">
      载具建筑
    </div>
    <div class="article">
      <div class="picture">
        <div class="big">
          <img src="./images/model/vehicle/红旗HS.png">
          <div class="big_model_title">
            <!-- 单导设备 -->
          </div>
          <div class="big_model_describe">
            <!-- 文艺、简约、品位，从此兼得 -->
          </div>
          <div class="big_title">
            红旗汽车
          </div>
        </div>
        <div class="small" style="margin-right: 30px;">
          <img src="./images/model/vehicle/军舰.png">
          <div class="small_model_title">
            军舰
          </div>
        </div>
        <div class="small">
          <img src="./images/model/vehicle/考斯特.png">
          <div class="small_model_title">
            考斯特
          </div>
        </div>
        <div class="small" style="margin-right: 30px;">
          <img src="./images/model/building/机房.png">
          <div class="small_model_title">
            机房
          </div>
        </div>
        <div class="small">
          <img src="./images/model/building/展台.png">
          <div class="small_model_title">
            展台
          </div>
        </div>
      </div>

      <div class="picture" v-if="detail3">
        <div class="big">
          <img src="./images/model/building/会展中心楼.png">
          <div class="big_model_title">
            <!-- 机器狗 -->
          </div>
          <div class="big_model_describe">
            <!-- 文艺、简约、品位，从此兼得 -->
          </div>
          <div class="big_title">
            会展中心楼
          </div>
        </div>
        <div class="small" style="margin-right: 30px;">
          <img src="./images/model/building/办公楼.png">
          <div class="small_model_title">
            办公楼
          </div>
        </div>
        <div class="small">
          <img src="./images/model/building/停车场.png">
          <div class="small_model_title">
            停车场
          </div>
        </div>
        <div class="small" style="margin-right: 30px;">
          <img src="./images/model/building/教学楼.png">
          <div class="small_model_title">
            教学楼
          </div>
        </div>
        <div class="small">
          <img src="./images/model/building/垃圾站.png">
          <div class="small_model_title">
            垃圾站
          </div>
        </div>
      </div>
      <div v-if="!detail3" class="more_model" @click="detail3 = true">
        更多模型
      </div>
      <div v-if="detail3" class="more_model" @click="detail3 = false">
        收起
      </div>
    </div>
    <div class="footer" ref="section6">
      <div class="center">
        <div class="left">
          <img src="./images/zbys.png">
          <span style="font-size: 22px;font-weight: bold;margin-bottom: 20px;">北京智步云上科技有限公司</span>
          <span>电话：130-5185-0850</span>
          <span>地址：北京市昌平区北清路1号院8号楼21层1单元2107</span>
        </div>
        <div class="right">
          <img src="./images/erweima.png">
          <span>扫码了解更多</span>
        </div>
        <div class="bottom">北京智步云上科技有限公司 备案/许可证编号：京ICP备2024066658号</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      detail1: false,
      detail2: false,
      detail3: false,
      form: {
        name: '',
        num: '',
        mail: '',
      }
    };
  },
  methods: {
    scrollToSection(sectionName) {
      const element = this.$refs[sectionName];
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth', // 平滑滚动效果
          block: 'start' // 滚动到元素顶部
        });
      }
    },
  },

};
</script>

<style lang="less" scoped>
.main {
  width: 100%;

  a {
    text-decoration: none;
    /* 去除下划线 */
    color: inherit;
    /* 让链接颜色继承父元素文本颜色，一般为黑色或默认文本颜色 */
    background-color: transparent;
    /* 背景透明 */
    border: none;
    /* 无边框 */
    outline: none;
    /* 移除聚焦时的轮廓 */
  }

  .nav {
    width: 100%;
    height: 70px;
    background: rgba(255, 255, 255, 0.9);
    position: fixed;
    z-index: 999;

    .center {
      width: 1200px;
      height: 100%;
      margin: 0 auto;

      img {
        display: block;
        float: left;
        vertical-align: middle;
        margin-top: 15px;
      }

      ul {
        height: 100%;
        list-style: none;
        width: 600px;
        margin: 0 auto;

        li {
          text-decoration-style: none;
          float: left;
          width: 100px;
          height: 100%;
          color: #000;
          line-height: 70px;
          text-align: center;
          transition: background 0.3s ease, color 0.3s ease;
        }

        li:hover {
          background: #0c0c54;
          color: #fff;
          cursor: pointer;
        }
      }
    }
  }

  .banner {
    width: 1200px;
    height: 635px;
    padding-top: 70px;
    margin: 0 auto;
  }

  .title {
    font-size: 30px;
    font-weight: bold;
    text-align: center;
    position: relative;
    margin: 100px auto 30px;
  }

  .title::after {
    content: '';
    width: 67px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: -10px;
    height: 4px;
    background-color: #0c0c54;
    margin: 0 auto;
  }

  .article {
    width: 1200px;
    // height: 680px;
    box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
    margin: 0 auto;
    padding: 70px 55px 70px;

    .picture {
      height: 440px;
      display: block;
    }
  }

  .big {
    width: 540px;
    height: 440px;
    float: left;
    margin-right: 40px;
    position: relative;

    img {
      width: 100%;
      height: 390px;
      border-radius: 5px;
      box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.2);
      float: left;
    }

    .big_title {
      width: 100%;
      height: 50px;
      float: left;
      font-size: 20px;
      font-weight: bold;
      line-height: 40px;
      color: #0c0c54;
      text-align: center;
      float: left;
    }

    .big_model_title {
      width: 200px;
      text-align: center;
      position: absolute;
      font-size: 20px;
      font-weight: bold;
      // color: #44525e;
      color: #fff;
      top: 50px;
      left: 0;
      bottom: 0;
      right: 0;
      margin: 0 auto;
    }

    .big_model_describe {
      width: 300px;
      text-align: center;
      position: absolute;
      // color: #627896;
      color: #fff;
      top: 90px;
      left: 0;
      right: 0;
      bottom: 0;
      margin: 0 auto;
    }
  }

  .small {
    width: 240px;
    height: 220px;
    float: left;

    img {
      width: 100%;
      height: 170px;
      float: left;
      box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2);
      border-radius: 5px;

    }

    .small_model_title {
      width: 100%;
      height: 50px;
      float: left;
      font-size: 20px;
      font-weight: bold;
      line-height: 40px;
      color: #0c0c54;
      text-align: center;
    }
  }

  .more_model {
    width: 190px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 18px;
    border: 1px solid #0c0c54;
    color: #44525e;
    margin: 30px auto 0;
    border-radius: 5px;
    transition: background 0.5s ease, color 0.3s ease;

  }

  .more_model:hover {
    background: #0c0c54;
    color: #fff;
    cursor: pointer;
  }

  .footer {
    height: 500px;
    width: 100%;
    margin-top: 100px;
    background: #161f24;
    float: left;

    .center {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      padding: 0;

      .left {
        height: 400px;
        float: left;
        padding: 50px 0;
        background: transparent;

        img {
          display: block;
          margin-bottom: 50px;
        }

        span {
          line-height: 30px;
          color: #fff;
          display: block;
        }
      }

      .right {
        height: 400px;
        float: right;
        padding: 50px 0;
        background: transparent;

        img {
          width: 200px;
          height: 200px;
          display: block;
          margin-bottom: 20px;
        }

        span {
          margin-left: 45px;
          color: #fff;
          font-size: 18px;
          font-weight: bold;
        }
      }

      .bottom {
        width: 100%;
        height: 100px;
        float: left;
        text-align: center;
        color: #666;
        line-height: 100px;
      }
    }

  }
}
</style>